import { css } from 'linaria';
import classNames from 'classnames';
const bubbleStyles = "b1bq2cra";
const floatingBubble = "f1806ge7";
export const InlineNotification = props => <span {...props} aria-hidden="true" className={bubbleStyles} />;
export const FloatingNotification = props => <span {...props} aria-hidden="true" className={classNames(bubbleStyles, floatingBubble)} />;

require("./notification.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./notification.js");